import React, { useState } from 'react';
import ReactJoyride from 'react-joyride';
import { useTranslation } from 'react-i18next';
import './HeaderTour.scss';
var HeaderTour = function () {
    var t = useTranslation().t;
    var _a = useState(false), start = _a[0], SetStart = _a[1];
    var steps = [
        {
            title: React.createElement("h4", { className: 'tourTitle' }, t("TS_core:ScaniaLogo")),
            target: '#scania-logo',
            content: React.createElement("p", { className: "UserTour" }, t("TS_core:W_ScaniaLogo")),
            disableBeacon: true
        },
        {
            title: React.createElement("h4", { className: 'tourTitle' }, t("TS_core:ApplicationLauncher")),
            target: '#AppLancher_tour_id',
            content: React.createElement("p", { className: "UserTour" }, t("TS_core:W_AppLauncher"))
        },
        {
            title: React.createElement("h4", { className: 'tourTitle' }, t('TS_core:Profile')),
            target: '#profile_tour_id',
            content: React.createElement("p", { className: "UserTour" }, t("TS_core:W_Profile"))
        },
        {
            title: React.createElement("h4", { className: 'tourTitle' }, t("TS_core:UniversalSearch")),
            target: '#universalSearch_tour_id',
            content: React.createElement("p", { className: "UserTour" }, t("TS_core:W_searchBar"))
        }
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { className: 'sdds-nav__dropdown-item-core', onClick: function () { return SetStart(!start); } }, t("TS_core:Header")),
        React.createElement(ReactJoyride, { steps: steps, run: start, continuous: true, showSkipButton: true, spotlightClicks: false, hideBackButton: false, hideCloseButton: true, locale: {
                next: t("TS_core:Next"),
                skip: t("TS_core:Skip"),
                back: t("TS_core:Back"),
                last: t("TS_core:Done")
            }, styles: {
                options: {
                    arrowColor: "#16417F",
                    backgroundColor: "white",
                    primaryColor: "#16417F",
                    overlayColor: "transparent",
                    beaconSize: 70
                },
                spotlight: {
                    backgroundColor: "rgba(45, 20, 201, .3)"
                },
                buttonSkip: {
                    color: "#2058A8"
                }
            } })));
};
export default HeaderTour;
